window.U3 = {
 "blocks": [
  {
   "id": "edc",
   "label": "Everyday EDC",
   "sub": "The cutouts you touch every week",
   "tools": [
    {
     "n": 9,
     "ref": 32,
     "side": "A",
     "x": 8.8,
     "y": 43.1,
     "est": false,
     "cat": "OPEN",
     "name": "Bottle opener",
     "desc": "The most-used cutout on any card, tuned to lift caps first try.",
     "sc": "Friday, lake, capped bottles. You're the hero again."
    },
    {
     "n": 10,
     "ref": 27,
     "side": "A",
     "x": 88.3,
     "y": 74.8,
     "est": false,
     "cat": "OPEN",
     "name": "Box opener",
     "desc": "Hooked tape-cutting edge — opens cartons, spares the contents.",
     "sc": "Daily parcels opened without stabbing what's inside."
    },
    {
     "n": 11,
     "ref": 6,
     "side": "A",
     "x": 11.2,
     "y": 86.2,
     "est": false,
     "cat": "DRIVE",
     "name": "Flat screwdriver",
     "desc": "Reinforced flat-blade tip on the card edge with real torque.",
     "sc": "Tighten a sagging door hinge on the way out of the house."
    },
    {
     "n": 12,
     "ref": 29,
     "side": "A",
     "mx": 8.4,
     "my": 8.6,
     "est": false,
     "cat": "DRIVE",
     "name": "1/4\" & 1/8\" bit driver",
     "desc": "Square sockets that hold standard screwdriver bits.",
     "sc": "Any bit from the drawer becomes a wallet screwdriver."
    },
    {
     "n": 13,
     "ref": 20,
     "side": "A",
     "x": 88.3,
     "y": 13.7,
     "est": false,
     "cat": "PRY",
     "name": "Pry bar",
     "desc": "Reinforced edge corner for prying lids and seams — save your fingernails.",
     "sc": "Paint tin lid, phone-free: pry, stir, done."
    },
    {
     "n": 14,
     "ref": 19,
     "side": "A",
     "x": 83.5,
     "y": 8.4,
     "est": false,
     "cat": "PRY",
     "name": "Nail puller",
     "desc": "Tapered claw slot that grips nail heads for levering out.",
     "sc": "Pull the staples-and-nails mess off a pallet for a weekend project."
    },
    {
     "n": 15,
     "ref": 2,
     "side": "B",
     "est": false,
     "cat": "GRILL",
     "name": "BBQ grill scraper",
     "desc": "Zig-zag edge that follows round grill bars and scrapes them clean.",
     "sc": "Someone else's crusty campsite grate, sorted before the steaks go on.",
     "mx": 80.9,
     "my": 3.4
    },
    {
     "n": 16,
     "ref": 38,
     "side": "B",
     "mx": 81,
     "my": 51.3,
     "est": false,
     "cat": "GAUGE",
     "name": "Tyre depth gauge",
     "desc": "Stepped corner that reads tread depth against the legal limit.",
     "sc": "Check the tread before winter — sell the excuse, not the car."
    }
   ]
  },
  {
   "id": "survival",
   "label": "Survival & fire",
   "sub": "Chop, cut, cook, light a fire",
   "tools": [
    {
     "n": 1,
     "ref": 21,
     "side": "A",
     "est": false,
     "cat": "SURVIVAL",
     "name": "Survival axe",
     "desc": "Mounts to a stick to become a compact chopping edge.",
     "sc": "Split kindling at camp with a lashed-on handle.",
     "mx": 84.1,
     "my": 20.3
    },
    {
     "n": 2,
     "ref": 22,
     "side": "A",
     "est": false,
     "cat": "SURVIVAL",
     "name": "Shovel",
     "desc": "Scoop profile — lash it to a handle for digging duty.",
     "sc": "Dig a drainage trench around the tent in a downpour.",
     "mx": 83.5,
     "my": 26
    },
    {
     "n": 3,
     "ref": 23,
     "side": "A",
     "est": false,
     "cat": "SURVIVAL",
     "name": "Scraper",
     "desc": "Broad flat edge for scraping hide, bark, ice or paint.",
     "sc": "Frosted windshield, scraper in the wallet. Morning saved.",
     "mx": 82.9,
     "my": 30.8
    },
    {
     "n": 4,
     "ref": 9,
     "side": "A",
     "x": 43.8,
     "y": 78.3,
     "est": false,
     "cat": "FIRE",
     "name": "Firestarter",
     "desc": "Hardened scraper spots that throw sparks off a ferro rod.",
     "sc": "Lighter soaked in a river crossing; the ferro rod still works."
    },
    {
     "n": 5,
     "ref": 28,
     "side": "A",
     "x": 73.9,
     "y": 76.2,
     "est": false,
     "cat": "CUT",
     "name": "Knife",
     "desc": "Sharpened section of the bottom edge for real cutting jobs.",
     "sc": "Cheese, cord and cardboard at a roadside picnic."
    },
    {
     "n": 6,
     "ref": 7,
     "side": "A",
     "x": 28.7,
     "y": 76.4,
     "est": false,
     "cat": "CUT",
     "name": "Cord cutter",
     "desc": "Recessed slot that cuts cord and zip-ties with no exposed blade.",
     "sc": "Zip-tied packaging in the parking lot — cut without a knife."
    },
    {
     "n": 7,
     "ref": 8,
     "side": "A",
     "x": 20.1,
     "y": 83.1,
     "est": false,
     "cat": "OPEN",
     "name": "Can opener",
     "desc": "Classic lever-style can edge, sharpened where it bites the lid.",
     "sc": "Beans at camp. The one tool everyone forgets, in your wallet."
    },
    {
     "n": 8,
     "ref": 10,
     "side": "A",
     "mx": 27.1,
     "my": 55,
     "est": false,
     "cat": "FILE",
     "name": "Rasp & nail file",
     "desc": "Wavy filing edge — 6 and 8 mm pitch — for wood, plastic and nails.",
     "sc": "Smooth a splintered tent-pole end before it shreds the sleeve."
    }
   ]
  },
  {
   "id": "wrench",
   "label": "Wrench & bike",
   "sub": "Nuts, spokes, wires",
   "tools": [
    {
     "n": 17,
     "ref": 5,
     "side": "A",
     "x": 49.2,
     "y": 47.2,
     "est": false,
     "cat": "WRENCH",
     "name": "15 mm, 13 mm wrench",
     "desc": "The two most common big metric nuts on bikes and furniture.",
     "sc": "15 mm is every bike axle nut ever. It's on the card."
    },
    {
     "n": 18,
     "ref": 12,
     "side": "A",
     "x": 58.5,
     "y": 26.5,
     "est": false,
     "cat": "WRENCH",
     "name": "5/16\"–1/2\" + 10, 12 mm wrench",
     "desc": "Mixed metric/imperial set covering the mid range in one row.",
     "sc": "Drone prop nuts, shelf bolts, hose fittings — one cutout row."
    },
    {
     "n": 19,
     "ref": 37,
     "side": "A",
     "mx": 8.5,
     "my": 42.4,
     "est": false,
     "cat": "WRENCH",
     "name": "4, 5, 5.5 mm wrench",
     "desc": "The small-metric trio for electronics and bike fittings.",
     "sc": "Tighten a 5 mm standoff on a 3D-printer frame mid-print."
    },
    {
     "n": 20,
     "ref": 31,
     "side": "A",
     "mx": 41.6,
     "my": 11.3,
     "est": false,
     "cat": "WRENCH",
     "name": "Butterfly wrench",
     "desc": "Winged cutout that grips wing nuts and thumbscrews.",
     "sc": "Seized wing nut on a garden hose reel — leverage, not fingers."
    },
    {
     "n": 21,
     "ref": 1,
     "side": "A",
     "x": 18.4,
     "y": 14.6,
     "est": false,
     "cat": "BIKE",
     "name": "14ga spoke wrench",
     "desc": "Spoke key for 14-gauge spokes, machined into the top notch.",
     "sc": "True a commuter wheel at the bike rack before it rubs the brake pad."
    },
    {
     "n": 22,
     "ref": 3,
     "side": "A",
     "x": 11.4,
     "y": 44,
     "est": false,
     "cat": "BIKE",
     "name": "13ga & 15ga spoke wrench",
     "desc": "Two more spoke gauges, covering older and heavy-duty wheels.",
     "sc": "Cargo-bike spokes are 13ga — this is the key that fits them."
    },
    {
     "n": 23,
     "ref": 35,
     "side": "A",
     "mx": 34.6,
     "my": 43.3,
     "est": false,
     "cat": "WIRE",
     "name": "Wire stripper",
     "desc": "Sized notches that strip insulation without nicking the core.",
     "sc": "Splice a trailer-light wire in a fuel-station car park."
    },
    {
     "n": 24,
     "ref": 4,
     "side": "A",
     "mx": 26.3,
     "my": 23.6,
     "est": false,
     "cat": "WRENCH",
     "name": "11/16\", 10/16\", 9/16\" wrench",
     "desc": "Imperial open-wrench cutouts along the diagonal spine.",
     "sc": "US-spec camp stove fitting — 9/16\" where no wrench set exists."
    },
    {
     "n": 25,
     "ref": 30,
     "side": "A",
     "mx": 11.1,
     "my": 11.2,
     "est": false,
     "cat": "WRENCH",
     "name": "3/16\" wrench",
     "desc": "Small imperial cutout for electronics and skate hardware.",
     "sc": "Skateboard axle nuts at the park, no tool bag."
    },
    {
     "n": 26,
     "ref": 25,
     "side": "A",
     "mx": 69.6,
     "my": 39.2,
     "est": false,
     "cat": "WRENCH",
     "name": "Oxygen wrench",
     "desc": "Square cutout that fits standard gas-bottle valve keys.",
     "sc": "Open a welding or O₂ bottle when the key walked off."
    }
   ]
  },
  {
   "id": "measure",
   "label": "Measure & navigate",
   "sub": "Rulers, angles, sun and stars",
   "tools": [
    {
     "n": 27,
     "ref": 11,
     "side": "B",
     "x": 40.2,
     "y": 15.1,
     "est": false,
     "cat": "MEASURE",
     "name": "Metric ruler 0–60 mm",
     "desc": "Engraved millimetre scale along side B's top edge.",
     "sc": "Measure a bolt before the hardware store, not after."
    },
    {
     "n": 28,
     "ref": 18,
     "side": "A",
     "x": 40.8,
     "y": 12.5,
     "est": false,
     "cat": "MEASURE",
     "name": "Inch ruler 0–2\"",
     "desc": "Imperial scale along side A's top edge, 1/16\" graduations.",
     "sc": "Reading plans in inches on a metric card — no conversion."
    },
    {
     "n": 29,
     "ref": 24,
     "side": "A",
     "est": false,
     "cat": "MEASURE",
     "name": "Protractor 0–90°",
     "desc": "Engraved quarter-circle protractor readable to fine degrees.",
     "sc": "Set the mitre saw by the card when the gauge is off.",
     "mx": 60.2,
     "my": 29.1
    },
    {
     "n": 30,
     "ref": 17,
     "side": "B",
     "x": 18.6,
     "y": 93.8,
     "est": false,
     "cat": "MEASURE",
     "name": "L square",
     "desc": "The card's corner is a true 90° square with dual scales.",
     "sc": "Check a picture frame is actually square before gluing it."
    },
    {
     "n": 31,
     "ref": 14,
     "side": "B",
     "x": 37.9,
     "y": 63.7,
     "est": false,
     "cat": "NAVIGATE",
     "name": "Sundial clock",
     "desc": "Radial dial that reads time from a shadow — no battery.",
     "sc": "Phone at 0%. Level the card, read the shadow: ~4 pm, head back."
    },
    {
     "n": 32,
     "ref": 15,
     "side": "B",
     "x": 12.4,
     "y": 50.1,
     "est": false,
     "cat": "NAVIGATE",
     "name": "Sundial compass",
     "desc": "North/South hemisphere scales for rough bearing from the sun.",
     "sc": "Cloudless sky and no signal — orient the map the old way."
    },
    {
     "n": 33,
     "ref": 16,
     "side": "B",
     "x": 62.6,
     "y": 75.1,
     "est": false,
     "cat": "MEASURE",
     "name": "Metric & inch compass",
     "desc": "Pivot hole plus pen holes to sweep exact circles in mm or inches.",
     "sc": "Draw a clean Ø50 circle for a speaker cutout template."
    },
    {
     "n": 34,
     "ref": 36,
     "side": "B",
     "mx": 64.5,
     "my": 40.6,
     "est": false,
     "cat": "GAUGE",
     "name": "Drill gauge Ø1.5–5",
     "desc": "Ø-marked holes from 1.5 to 5 mm that identify drill bits and wire.",
     "sc": "Unmarked bits from the jar, identified in seconds."
    },
    {
     "n": 35,
     "ref": 34,
     "side": "B",
     "mx": 42.4,
     "my": 28.7,
     "est": false,
     "cat": "NAVIGATE",
     "name": "Distance ruler",
     "desc": "Map-range scale — sight a known-height object, read distance.",
     "sc": "Estimate how far the far shore is before committing to the paddle."
    },
    {
     "n": 36,
     "ref": 33,
     "side": "B",
     "mx": 55.5,
     "my": 0,
     "est": false,
     "cat": "MEASURE",
     "name": "Quick angle",
     "desc": "Preset angle edges for marking common cuts fast.",
     "sc": "Mark 45° on trim without unpacking the mitre box."
    }
   ]
  }
 ]
};
